define(function(require, exports, module) {
    'use strict';

    var $ = require('j');
    var BaseView = require('common/base.view');

    module.exports = BaseView.extend({

        _detachRootClassNames: function() {
            var $html = $(document.documentElement);
            var codeInsertion = this.model && this.model.get('codeInsertion');
            var rootClassNames = codeInsertion && codeInsertion.rootClassNames;

            if (rootClassNames) {
                rootClassNames
                    .split(' ')
                    .forEach(function(className) {
                        $html.removeClass('root-' + className);
                    });
            }
        },

        /**
         * @override
         */
        close: function() {
            this._detachRootClassNames();

            BaseView.prototype.close.apply(this, arguments);
        }

    });
});
